// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import data_control from "../../../../../engines/libs/data_control";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";
import { backPackEventMap } from "../../../config/BackpackEventConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MilitaryEarningItem extends BaseComponent {

	@property({ type: cc.Label, displayName:'' })
	labelCount: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprGoods: cc.Sprite = null;

    private goodsId = '';
    private goodsCount = 0;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.intiUI();
    }

    setData(
        id: string
        , count: number
    ) {
        this.goodsId = id;
        this.goodsCount = count;
    }

    intiUI() {
        this.showGoods();
        this.labelCount.string = data_control.getNumberFormat(this.goodsCount);
    }

    async showGoods() {
        let goodsId = this.goodsId;
        let goodsConfig = backPackEventMap()[goodsId];
        let spPath = goodsConfig.spPath;
        let sprGoods = this.sprGoods;
        let gwidth = sprGoods.node.width * sprGoods.node.scaleX;
        let gheight = sprGoods.node.height * sprGoods.node.scaleY;
        sprGoods.node.active = false;

        this.labelName.string = goodsConfig.name;
        let iconPath = "backpackAssets/objSp/" + spPath;
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
        bundle.load(iconPath, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    sprGoods.node.active = true;
                    sprGoods.spriteFrame = imgs;

                    let scale = Math.min(gwidth / sprGoods.node.width, gheight / sprGoods.node.height);
                    sprGoods.node.scale = scale;    
                }
            }
        );
    }

    // update (dt) {}
}
